import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";
import type {
  AngelouCSS,
  ButtonStyleOverrides,
  CollapseStyleOverrides,
} from "@newsela/angelou";

const { ui } = constants.colors;

export const collapseButtonCss:
  | ButtonStyleOverrides<AngelouCSS>
  | CollapseStyleOverrides<AngelouCSS> = {
  root: {
    width: "100%",
  },
};

export const collapseCss: Partial<CollapseStyleOverrides<AngelouCSS>> = {
  root: {
    width: "100%",
    borderTop: `1px solid ${ui.neutral[100]}`,
    marginBlock: "0",
    "& h2": {
      marginBlock: "12px",
    },
  },
};

export const expanderContentCss: CSSObject = {
  marginBottom: "8px",
};

export const headerCss: CSSObject = {
  fontSize: "16px",
  lineHeight: "24px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
};
